webpackJsonp([84136735813116],{

/***/ 1426:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"DosageConfigInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"drugStrength","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"SCALAR","name":"Decimal","ofType":null}}},{"defaultValue":null,"description":null,"name":"speciesDosageConfigs","type":{"kind":"LIST","name":null,"ofType":{"kind":"INPUT_OBJECT","name":"SpeciesDosageConfigInput","ofType":null}}},{"defaultValue":null,"description":null,"name":"unit","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"SCALAR","name":"String","ofType":null}}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-dosage-config-input-71ff6dbedf62aa67283f.js